import {
  Directive,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';

@Directive({
  selector: '[aria-hidden]',
  standalone: true,
})
export class AriaHiddenTabindexDirective implements OnChanges {
  @Input('aria-hidden') ariaHidden: string;

  constructor(private readonly el: ElementRef<HTMLElement>) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (
      this.ariaHidden === 'true' &&
      this.el.nativeElement.tagName.toLowerCase() !== 'svg'
    ) {
      this.el.nativeElement.setAttribute('tabindex', '-1');
    } else {
      this.el.nativeElement.removeAttribute('tabindex');
    }
  }
}
